var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490 490",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.5,0h-385C23.5,0,0,23.5,0,52.5v385c0,29,23.5,52.5,52.5,52.5h385c29,0,52.5-23.5,52.5-52.5v-385 C490,23.5,466.5,0,437.5,0z M126.5,450C95.3,450,70,424.7,70,393.5S95.3,337,126.5,337s56.5,25.3,56.5,56.5S157.7,450,126.5,450z  M437.5,277.5c0,9.7-7.8,17.5-17.5,17.5H70c-9.7,0-17.5-7.8-17.5-17.5V70c0-9.7,7.8-17.5,17.5-17.5h350c9.7,0,17.5,7.8,17.5,17.5 V277.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvController);
export default __webpack_public_path__ + "static/media/env-controller.24951f4cb054469f8b8ef810b488013f.svg";
export { ForwardRef as ReactComponent };